import './App.css';
import { createBrowserRouter, RouterProvider, Link } from "react-router-dom"; 
import Login from './component/login/login';
import Register from './component/register/register'; 
import Dashboard from './component/dashboard/Dashboard';
import Home from './component/dashboard/Home';
import Invoices from './component/dashboard/Invoices';
import NewInvoice from './component/dashboard/NewInvoice';
import Setting from './component/dashboard/Setting';
import ViewInvoice from './component/dashboard/ViewInvoice';
import Rates from './component/dashboard/Rates';
import Payments from './component/dashboard/Payments';
import ViewReceipt from './component/dashboard/ViewReceipt';
import EditPayment from './component/dashboard/EditPayment';
import FullReport from './component/dashboard/FullReport';
import CombinedReport from './component/dashboard/CombinedReport';
import BookingReport from './component/dashboard/BookingReport';
import CnUpload from './component/dashboard/CnUpload';
import InvoiceReceipts from './component/dashboard/InvoiceReceipts'; 
import ShipmentInvoice from './component/dashboard/ShipmentInvoice'; 

// Notun file import kora hoyeche
import BookingAccounts from './component/dashboard/BookingAccounts'; 
import BookingRates from './component/dashboard/BookingRates'; 

import ProtectedRoute from './component/ProtectedRoute';

function App() {
  const myRouter = createBrowserRouter([ 
    {path:'',Component:Login},
    {path:'/login',Component:Login},
    {path:'/register',Component:Register}, 

    {
      path:'/dashboard',
      element: (
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      ),
      children:[
        {path:'',Component:Home},
        {path:'home',Component:Home},
        {path:'invoices',Component:Invoices},
        {path:'new-invoice',Component:NewInvoice,},
        {path:'setting',Component:Setting},
        {path:'invoices/view/:invoiceId', Component: ViewInvoice},
        {path:'rates', Component:Rates},
        {path:'booking-report', Component:BookingReport},
        
        {path:'booking-accounts', Component:BookingAccounts},
        // Notun BookingRates route add kora holo
        {path:'booking-rates', Component:BookingRates},

        {path:'cn-upload', Component:CnUpload},
        {path:'payments', Component:Payments},
        {path:'payments/view/:paymentId', Component: ViewReceipt},
        {path:'payments/edit/:paymentId', Component: EditPayment},
        {path:'full-report', Component: FullReport},
        {path:'full-report/receipts/:invoiceId', Component: InvoiceReceipts}, 
        {path:'combined-report', Component: CombinedReport},
        {path:'create-shipment-invoice', Component: ShipmentInvoice},
      ]
    }, 

    {
      path: "*",
      element: (
        <div style={{textAlign: 'center', marginTop: '50px'}}>
            <h1>404</h1>
            <p>Page not found!</p>
            <Link to="/dashboard" style={{textDecoration: 'none', color: 'blue', fontWeight: 'bold'}}>
              Go Home
            </Link>
        </div>
      )
    }
  ])

  return (
    <div>
      <RouterProvider router={myRouter} />
    </div>
  );
}

export default App;